import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import LinkColumnItem from '../LinkColumn/LinkColumnItem';

import { ConnectRow_viewer } from './__generated__/ConnectRow_viewer.graphql';
import { SocialLinkRowItemProps } from '../SocialLinkRow/SocialLinkRowItem';
import { connect } from 'react-redux';
import { SocialLinkRow } from '../SocialLinkRow/SocialLinkRow';
import { blog, magazine } from '../messages/connectLinks';
import classnames from 'classnames';

import styles from './ConnectRow.scss';

type Props = {
    items: SocialLinkRowItemProps[];
    isClient: boolean;
    isMobile: boolean;
    viewer: ConnectRow_viewer;
};
export const ConnectRowComponent: FC<Props> = ({ isMobile, items, viewer, isClient }) => {
    return (
        <li className={classnames(styles.container, { [styles.isMobile]: isMobile })}>
            <ul>
                <LinkColumnItem key={'footer-blog'} {...blog} />
                <LinkColumnItem key={'footer-magazine'} {...magazine} />
            </ul>
            <SocialLinkRow items={items} viewer={viewer} isClient={isClient} />
        </li>
    );
};

const mapStateToProps = ({ header }: { header: { isMobile: boolean } }): { isMobile: boolean } => ({
    isMobile: header.isMobile,
});

export const ConnectRow = createFragmentContainer(connect(mapStateToProps)(ConnectRowComponent), {
    viewer: graphql`
        fragment ConnectRow_viewer on Viewer {
            ...SocialLinkRow_viewer
        }
    `,
});
